<template>
  <div id="content" class="receiptproof">
    <h1>Gestion des lineitem partpubs</h1>
    <div v-if="!end">
      <div v-if="id" class="ratio_wrapper">
        <h2>Ratio proposé :</h2>
        <div class="ratio_menu">
          <input type="text" maxlength="3" v-model="ratio" /><span>%</span>
          <button @click="updateRatio" class="btn-blue">Je confirme</button>
        </div>
        <br />
        <br />
        <div>
          <p
            style="cursor:pointer;padding-bottom:20px;"
            v-clipboard:copy="id"
            v-clipboard:success="onCopy"
          >
            Lineitem id : {{ this.id }}
          </p>
          <vue-tabs @tab-change="handleTabChange">
            <v-tab title="receipt"> </v-tab>
            <v-tab title="invoice"> </v-tab>
          </vue-tabs>
        </div>
        <div class="ratio_pdf_viewver">
          <div v-show="tabIndex === 0 && ext1 === 'pdf'">
            <p v-if="isLoading"> &nbsp; Chargement du document en cours...</p>
            <vue-pdf-embed :source="source" @rendered="handleDocumentRender" />
          </div>
          <div v-show="tabIndex === 1 && ext2 === 'pdf'">
            <p v-if="isLoading"> &nbsp; Chargement du document en cours...</p>
            <vue-pdf-embed :source="source2" @rendered="handleDocumentRender" />
          </div>

          <div class="images">
            <img v-show="tabIndex === 0 && ext1 === 'image'" :src="source" />
            <img v-show="tabIndex === 1 && ext2 === 'image'" :src="source2" />
          </div>

          <div class="videos">
           <video v-show="tabIndex === 0 && ext1 === 'video'" controls="controls" :src="source">Your browser does not support the HTML5 Video element.</video>
           <video v-show="tabIndex === 1 && ext2 === 'video'" controls="controls" :src="source2">Your browser does not support the HTML5 Video element.</video>
          </div>

          <div class="audios">
            <audio v-show="tabIndex === 0 && ext1 === 'audio'"  controls :src="source">Your browser does not support the audio element.</audio>
            <audio v-show="tabIndex === 1 && ext2 === 'audio'"  controls :src="source2">Your browser does not support the audio element.</audio>            
          </div>   

        </div>
      </div>
    </div>
    <div v-else>
      <h2>Aucun lineitem à traiter</h2>
    </div>

  </div>
</template>
<script>
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.css";

export default {
  components: {
    VuePdfEmbed,
    VueTabs,
    VTab,
  },
  data() {
    return {
      id: undefined,
      source: undefined,
      source2: undefined,
      ext1: undefined,
      ext2: undefined,
      ratio: undefined,
      isLoading: false,
      end: false,
      tabIndex: 0,
    };
  },
  mounted() {
    this.getItem();
  },
  methods: {
    onCopy(tag) {
      this.$swal({
        position: "top-end",
        type: "success",
        title: tag.text + " copié avec succès",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    handleTabChange(tabIndex) {
      this.tabIndex = tabIndex;
    },
    async updateRatio() {
      try {
        let result = await this.$axios.post("/api/operations-custom/partpubs/setratio",
          {
            _id: this.id,
            ratio: this.ratio / 100,
          }
        );

        this.id = false;
        this.getItem();
      } catch (e) {
        console.log(e);
      }
    },
    handleDocumentRender() {
      this.isLoading = false;
    },
    getExt(filename) {
      var ext = /[.]/.exec(filename) ? /[^.]+$/.exec(filename) : undefined;

      if (
        ext[0] === "png" ||
        ext[0] === "jpg" ||
        ext[0] === "jpeg" ||
        ext[0] === "heic" ||
        ext[0] === "gif"
      ) {
        return "image";
      } else if (
        ext[0] === "mp4" ||
        ext[0] === "avi" ||
        ext[0] === "mov" ||
        ext[0] === "mpeg"
      ) {
        return "video";
      } else if (ext[0] === "mp3" || ext[0] === "wav") {
        return "audio";
      } else {
        return "pdf";
      }
    },
    async getItem() {
      this.isLoading = true;
      try {
        let { data } = await this.$axios.get(`/api/operations-custom/partpubs/item`);
        this.id = data._id;
        this.ratio = data.ratio * 100;

        this.ext1 = this.getExt(data.receipt);
        if(this.ext1 === 'video' || this.ext1 === 'audio') {
            this.source =data.receipt
        } else {
          this.source =
            "https://passerelle-do.netlify.app/.netlify/functions/passerelle?url=" +
            data.receipt;
        }


        this.ext2 = this.getExt(data.invoice);
        if(this.ext2 === 'video' || this.ext2 === 'audio') {
          this.source2 =data.invoice
        } else {
          this.source2 =
            "https://passerelle-do.netlify.app/.netlify/functions/passerelle?url=" +
            data.invoice;
        }

        if (!data._id) {
          this.end = true;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style lang="scss">
.receiptproof {
  h1 {
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    padding-top: 20px;
  }
}

.ratio_wrapper {
  padding: 10px 20px 20px 20px;

  b {
    display: block;
    margin-bottom: 10px;
  }
}

.ratio_pdf_viewver {
  max-height: 800px;
  overflow: auto;
  border-left: solid 1px #ddd;
  border-right: solid 1px #ddd;
  border-bottom: solid 1px #ddd;

  video {
    width: 100%;
  }

  .images {
    width: 100%;
    img {
      width: 100%;
    }
  }
}

.ratio_menu {
  position: relative;
  span {
    position: absolute;
    z-index: 2;
    left: 55px;
    top: 12px;
  }
  input {
    width: 39px;
    margin-right: 10px;
  }

  button {
    text-transform: uppercase;
  }
}
</style>
